<div>
    <p>{{message}}</p>  
</div>